export class EnumHelper {
    static toSelectOptions<T extends Record<string, string | number>>(enumObj: T) {
      return Object.keys(enumObj)
        .filter((key) => isNaN(Number(key))) // Filter out numeric values
        .map((key) => ({
          label: key, // Format label
          value: enumObj[key as keyof T], // Get numeric value
        }));
    }
  }
  